import { inlineJsonMarker } from './inlineJsonMarker'

export const ATTACHMENT_CHIPS_MARKER = '__ATTACHMENT_CHIPS__'

export type AttachmentCandidate = {
  name: string
  path: string
  score: number
  source: 'shared_drives' | 'finance' | 'thread'
  size_bytes: number
  mtime?: number
}

export type AttachmentChipsPayload = {
  draft_id: string
  candidates: AttachmentCandidate[]
}

const attachmentChipsMarker = inlineJsonMarker<AttachmentChipsPayload>(ATTACHMENT_CHIPS_MARKER)

export const parseAttachmentChips = attachmentChipsMarker.parse
export const splitAttachmentChips = attachmentChipsMarker.split
